import React from 'react';
import { BonusSection } from './components/BonusSection';
import { ClosingSection } from './components/ClosingSection';
import { FAQ } from './components/FAQ';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { GuaranteeSection } from './components/GuaranteeSection';
import { Hero } from './components/Hero';
import { MetaPixel } from './components/MetaPixel';
import { ModulesSection } from './components/ModulesSection';
import { MoreResults } from './components/MoreResults';
import { PricingSection } from './components/PricingSection';
import { ProblemSection } from './components/ProblemSection';
import { PurchaseNotification } from './components/PurchaseNotification';
import { SocialProof } from './components/SocialProof';
import { SummaryTable } from './components/SummaryTable';
import { SystemSection } from './components/SystemSection';
import { Testimonials } from './components/Testimonials';
import { UrgencySection } from './components/UrgencySection';
export function App() {
  return <div className="min-h-screen w-full overflow-hidden bg-mist text-ink" data-id="element-0" data-mp="3ii4s22026sok">
      <MetaPixel data-id="element-1" data-mp="3mjq1fdddwou0" />
      <main data-id="element-2" data-mp="3mj6ibtbzzuee">
        <Hero data-id="element-3" data-mp="3rc9dg5wfbbwp" />
        <SocialProof data-id="element-4" data-mp="3rbra6pbcfxfa" />
        <Testimonials data-id="element-5" data-mp="3rdar8i4tqci4" />
        <ProblemSection data-id="element-6" data-mp="3rd1azm9kzjpm" />
        <SystemSection data-id="element-7" data-mp="3relwynhtxubv" />
        <ModulesSection data-id="element-8" data-mp="6hp9c27i9cj" />
        <BonusSection data-id="element-9" data-mp="4n4pyuukj8z" />
        <UrgencySection data-id="element-10" data-mp="56l3b4umzkw" />
        <PricingSection data-id="element-11" data-mp="2zl3azit8d249" />
        <MoreResults data-id="element-12" data-mp="2zlv6ktmtuzuj" />
        <GuaranteeSection data-id="element-13" data-mp="2zmeo498kfm81" />
        <FAQ data-id="element-14" data-mp="2zn6b4vo3kbmp" />
        <ClosingSection data-id="element-15" data-mp="2znfy0adui2o6" />
        <SummaryTable data-id="element-16" data-mp="33m5c656pjo8v" />
        <FinalCta data-id="element-17" data-mp="33ngf62sbwryx" />
      </main>
      <Footer data-id="element-18" data-mp="33orjq4tlm3r3" />
      <PurchaseNotification data-id="element-19" data-mp="38lrp0dimj2h5" />
    </div>;
}